import React from "react"
import logo from "../../public/assets/images/ontario_logo.svg"
import { CommentDetail, HeaderConfig, ProgramContainer } from "../entities/formTemplateDataType";
import '../../public/assets/css/App.css';
import UserComponent from "../security/UserComponent";
import SocialMediaComponent from "./SocialMediaComponent";
import { ModalComponent } from "../runtimeComponent/subComponent/ModalComponent";
import { BsChatRightDots } from "react-icons/bs";
import CustomPopup from "../runtimeComponent/subComponent/PopupComponent";
import CMACommentListComponent from "../runtimeComponent/subComponent/cma/CMACommentsListComponent";
import { showComments } from "../utilities/custom/CmaUtils";
import { TemplateStatus } from "../entities/Constants";

interface Props {
  programContainer: ProgramContainer;
  headerConfig?: HeaderConfig
  isEng: boolean;
  profile?: any;
  comments?: CommentDetail[];
  callbackState?: (p: ProgramContainer) => void;
  callback;
  callbackLogin?;
  callbackCMASaved?: () => void;
}

interface State {
  helpActive: boolean;
  commentsActive: boolean;
}

export class RuntimeHeaderComponent extends React.Component<Props, State> {
  //  msalInstance = new PublicClientApplication(msalConfig);

  constructor(props: Props) {
    super(props);

    this.state = {
      helpActive: false,
      commentsActive: false,
    }

  }

  addFrToUrl = () => {
    const enUrlString = window.location.href;
    sessionStorage.setItem("previousUrl", enUrlString);
    const frUrlString = enUrlString.replace("/on-form/", "/on-form/fr/");
    window.history.pushState({}, "", frUrlString);
    sessionStorage.setItem("languageChange", "true");
  };
  
  removeFrToUrl = () => {
    const url = window.location.href;
    sessionStorage.setItem("previousUrl", url);
    sessionStorage.setItem("languageChange", "true");
    if (url.includes("/fr")) {
      const newUrl = url.replace("/fr", "");
      window.history.pushState(null, "", newUrl);
    }
  };

  generateHeaderString = () => {
    const HtmlToReactParser = require('html-to-react').Parser;
    const htmlToReactParser = new HtmlToReactParser();
    const cmaRole = this.props.programContainer.userRole?.split(',')?.reduce((finalRole, role) => finalRole === 'A' ? finalRole : role === 'Assessor' ? 'C' : role.charAt(0), '');
    const tempStatus = this.props.programContainer.Entity?.status;
    const readOnlyComments = [TemplateStatus.SUBMITTED, TemplateStatus.COMPLETED].includes(tempStatus) && this.props.programContainer.Entity?.comments;

    return (
      <div className='documentation-only--application'>
        <div className='ontario-header__container'>
          <header className='ontario-application-header ontario-header' id='ontario-header'>
            <div className='ontario-row'>
              <div className='ontario-columns ontario-small-6 ontario-application-header__logo'>
                <a href={this.props.isEng ? 'https://www.ontario.ca/page/government-ontario' : 'https://www.ontario.ca/fr/page/gouvernement-de-lontario'}>
                  <img id="asap-logo" src={logo} alt={this.props.isEng ? "Government of Ontario" : 'Gouvernement de l’Ontario'}/>
                </a>
                {this.props.programContainer?.CategoryId?.toUpperCase()=="CMA" && <a href={`http://cybersecurityontario.gov.on.ca/sso?autologin${this.props.isEng ? "" : "&lang=fr_ca"}`} target="_blank" className='navbar-brand aabtn has-logo'>
                  <span className="cyber-security-ontario-text">{this.props.isEng ? "| Cyber Security Ontario" : "| Cybersécurité Ontario"}</span>
                </a>}
              </div>
              <div style={{ display: this.props.programContainer.EnglishOnly ? "none" : "block" }} className='ontario-columns ontario-small-6 ontario-application-header__lang-toggle'>
                {!this.props.programContainer.EnglishOnly && <button lang={this.props.isEng ? 'fr' : 'en'} className='ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline'
                  onClick={() => {
                    if (this.props?.programContainer?.CategoryId === "CMA") {
                      if (this.props.isEng) {
                        this.addFrToUrl();
                      } else {
                        this.removeFrToUrl();
                      }
                    }
                    this.props.callback(!this.props.isEng);
                  }
                }> {this.props.isEng ? 'Français' : 'English'}</button>}
              </div>
            </div>
          </header>
          <div className='ontario-application-subheader-menu__container'>
            <section className='ontario-application-subheader'>
              <div className='ontario-row'>
                <div className='ontario-columns ontario-small-12 ontario-application-subheader__container'>
                  <p className='ontario-application-subheader__heading'>
                    <a className="not-clickable" style={{ whiteSpace: 'pre-wrap' }}>{this.props.isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA}</a>
                  </p>
                  <div style={{ display: this.props.programContainer.SocialMedia == "Y" ? "block" : "none", background: 'white' }} >
                    <SocialMediaComponent isEng={this.props.isEng} GATrackingID={this.props.programContainer.GATrackingID}></SocialMediaComponent>
                  </div>
                  <div className='ontario-application-subheader__menu-container' style={{ display: this.props.programContainer.HelpOption ? "block" : "none" }}>
                    <ul className='ontario-application-subheader__menu'>
                      <li><a style={{ cursor: "pointer" }} onClick={() => this.setState({ helpActive: !this.state.helpActive })}>{this.props.isEng ? "Help" : "Aide"}</a></li>
                    </ul>
                  </div>
                  <ModalComponent modalIsOpen={this.state.helpActive} shouldCloseOnOverlayClick={true} onRequestClose={() => this.setState({ helpActive: false })}>
                    {this.props.isEng ? htmlToReactParser.parse(this.props.programContainer.HelpHeader) : htmlToReactParser.parse(this.props.programContainer.HelpHeaderFRA)}
                    {this.props.isEng ? htmlToReactParser.parse(this.props.programContainer.HelpRichText) : htmlToReactParser.parse(this.props.programContainer.HelpRichTextFRA)}
                    {this.props.isEng ? htmlToReactParser.parse(this.props.programContainer.HelpFooter) : htmlToReactParser.parse(this.props.programContainer.HelpFooterFRA)}
                    <button
                      className="ontario-button ontario-button--primary"
                      onClick={() => this.setState({ helpActive: false })}
                    >{this.props.isEng ? "Close" : "Fermer"}</button>
                  </ModalComponent>
                  {this.props.programContainer.AuthRequired == "ad" && (
                    <div className="ontario-runtime-header-comment-container">
                        <div className='ontario-application-subheader__heading'>
                          <UserComponent isEng={this.props.isEng} categoryId={this.props.programContainer.CategoryId} scopes={this.props.programContainer.Scopes} callback={() => {
                            this.props.callbackLogin();
                          }} />
                        </div>
                      
                      {this.props.headerConfig?.comments && ([TemplateStatus.APPROVAL_PENDING, TemplateStatus.REVISION].includes(tempStatus) || readOnlyComments) && (
                        <>
                          <button className="header__menu-toggler header-button header-button--with-outline message_button"
                            aria-expanded={this.state.commentsActive}
                            aria-labelledby="menu-button"
                            onClick={() => this.setState({ commentsActive: !this.state.commentsActive })}
                          >
                            <BsChatRightDots
                              size={24}
                              fill="#fff"
                              id='message-button'
                              role="presentation" focusable="false"
                            /> 
                            <span className="ontario-show-for-medium ontario-show">
                            {this.props.isEng ? "View Comments" : "Voir les commentaires"}
                            </span>
                          </button>
                          {this.state.commentsActive && (showComments(this.props.programContainer)) && (
                            <CustomPopup
                              id="customPopup"
                              onClickOutside={(closable = false) => {
                                if (!closable)
                                  this.setState({ commentsActive: false });
                              }}
                              title={this.props.isEng ? 'Comments' : 'Commentaires'}
                              isVisible={this.state.commentsActive}
                              closable={true}
                              handleModalClose={() => this.setState({ commentsActive: false })}
                              // handleCustomEvent={(e) => console.log('handle custom event')}
                              customClass="comments-modal"
                              customContentClass="custom-modal-height"
                            >
                              <CMACommentListComponent
                                programContainer={this.props.programContainer}
                                headerConfig={this.props.headerConfig}
                                comments={this.props.comments}
                                profile={this.props.profile}
                                cmaRole={cmaRole as 'A' | 'C'}
                                readOnly={readOnlyComments}
                                isEng={this.props.isEng}
                                cancelComments={() => this.setState({ commentsActive: false })}
                                callback={this.props.callbackState}
                                callbackCMASaved={() => this.props.callbackCMASaved()}            
                              />
                            </CustomPopup>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
        <div className='ontario-overlay'></div>
      </div>)

  }
  render() {
    return (
      <div style={{ marginBottom: '50px' }}>
        {this.generateHeaderString()}
      </div>

    )
  }
}
